const EmbeddedVideoPlayer = (el) => {

    const playButton = el.querySelector('.embedded-video-player__cover');
    const video = el.querySelector('.embedded-video-player__embedded');
    const label = el.querySelector('.embedded-video-player__label');

    playButton.addEventListener('click', playVideo);
    el.addEventListener('keydown', function (event) {
        if (el.activeElement !== playButton && el.activeElement !== video) return;
        if ((event.key === ' ' || event.key === 'Enter')) {
            event.preventDefault(); // Prevent scrolling when pressing Space
            playVideo();
            video.focus();
        }
    });

    function playVideo() {
        playButton.classList.add('h-hidden');
        label.classList.add('h-hidden');
        video.setAttribute('controls', 'controls');
        video.play();
    }

    function updateVideoPlayerContent(el, data) {
        const d = (data && data.data) || data;

        const video = el.querySelector('video');
        const durationEl = el.querySelector('.embedded-video-player__label');
        if (!video || !d) return;

        if (typeof d.coverImage === 'string') {
            video.poster = d.coverImage;
        }

        if (typeof d.url === 'string') {
            video.src = d.url;
            video.load();
        }

        if (durationEl && typeof d.label === 'string') {
            durationEl.textContent = d.label;
        }
    }

    function resetVideoPlayer(el) {
        const video = el.querySelector('video');
        const playButton = el.querySelector('.embedded-video-player__cover');
        const label = el.querySelector('.embedded-video-player__label');

        video.pause();
        video.removeAttribute('controls');
        playButton.classList.remove('h-hidden');
        label.classList.remove('h-hidden');
    }

    el.addEventListener('update', (data) => {
        updateVideoPlayerContent(el, data);
        resetVideoPlayer(el);
    });

    el.addEventListener('pause', () => {
        resetVideoPlayer(el);
    });
};

export default EmbeddedVideoPlayer;
